<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->


<div class="overlay" (click)="close()">
</div>
<div class="right-side">
  <well-right-side-animation>
    <router-outlet></router-outlet>
  </well-right-side-animation>
</div>


